/* @ds-bundle: {"format":3,"namespace":"BoniDesignSystem_dec8ad","components":[{"name":"Avatar","sourcePath":"components/core/Avatar.jsx"},{"name":"Badge","sourcePath":"components/core/Badge.jsx"},{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Card","sourcePath":"components/core/Card.jsx"},{"name":"Input","sourcePath":"components/core/Input.jsx"},{"name":"Rating","sourcePath":"components/core/Rating.jsx"},{"name":"Switch","sourcePath":"components/core/Switch.jsx"},{"name":"Dialog","sourcePath":"components/feedback/Dialog.jsx"},{"name":"Tabs","sourcePath":"components/navigation/Tabs.jsx"},{"name":"ProductCard","sourcePath":"components/product/ProductCard.jsx"}],"sourceHashes":{"components/core/Avatar.jsx":"551dd35cc876","components/core/Badge.jsx":"c32825d75110","components/core/Button.jsx":"c2fea80ab3cd","components/core/Card.jsx":"875e5cab2917","components/core/Input.jsx":"2a2e4aa8c8df","components/core/Rating.jsx":"e30ee96a41e6","components/core/Switch.jsx":"a069e2eae0c1","components/feedback/Dialog.jsx":"25690b498ca3","components/navigation/Tabs.jsx":"f756ba811d4d","components/product/ProductCard.jsx":"025d5becacd2","ui_kits/website/App.jsx":"510f84356bb2","ui_kits/website/Benefits.jsx":"5c85e0255043","ui_kits/website/Footer.jsx":"0629652f5764","ui_kits/website/Foundation.jsx":"7477898814b8","ui_kits/website/Header.jsx":"64d2f416c977","ui_kits/website/Hero.jsx":"d6f3c8c883ba","ui_kits/website/Icons.jsx":"8b53aca00ca1","ui_kits/website/IngredientBanner.jsx":"9988fe504b40","ui_kits/website/ProductGrid.jsx":"df2bd7a1d803","ui_kits/website/Testimonials.jsx":"f6602684da77"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.BoniDesignSystem_dec8ad = window.BoniDesignSystem_dec8ad || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/core/Avatar.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Avatar — a round, ink-outlined portrait for pets & people. Falls back
 * to initials on a tinted background when no image is supplied.
 */
function Avatar({
  src,
  alt = '',
  name = '',
  size = 44,
  tone = 'yellow',
  outline = true,
  style = {},
  ...rest
}) {
  const tones = {
    yellow: {
      bg: 'var(--yellow-200)',
      fg: 'var(--yellow-800)'
    },
    teal: {
      bg: 'var(--teal-100)',
      fg: 'var(--teal-600)'
    },
    coral: {
      bg: 'var(--coral-100)',
      fg: 'var(--coral-600)'
    },
    berry: {
      bg: 'var(--berry-100)',
      fg: 'var(--berry-600)'
    }
  };
  const t = tones[tone] || tones.yellow;
  const initials = name.split(' ').map(p => p[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      flex: 'none',
      borderRadius: '50%',
      overflow: 'hidden',
      background: t.bg,
      color: t.fg,
      border: outline ? '2px solid var(--ink-800)' : 'none',
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: size * 0.4,
      lineHeight: 1,
      ...style
    }
  }, rest), src ? /*#__PURE__*/React.createElement("img", {
    src: src,
    alt: alt || name,
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    }
  }) : initials || '🐾');
}
Object.assign(__ds_scope, { Avatar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Avatar.jsx", error: String((e && e.message) || e) }); }

// components/core/Badge.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Badge / Tag — a small rounded pill for statuses, categories and
 * product benefits. Tones map to the flavour palette.
 */
function Badge({
  children,
  tone = 'neutral',
  outline = false,
  size = 'md',
  iconLeft = null,
  style = {},
  ...rest
}) {
  const tones = {
    neutral: {
      bg: 'var(--cream-200)',
      fg: 'var(--ink-700)'
    },
    yellow: {
      bg: 'var(--yellow-200)',
      fg: 'var(--yellow-800)'
    },
    teal: {
      bg: 'var(--teal-100)',
      fg: 'var(--teal-600)'
    },
    coral: {
      bg: 'var(--coral-100)',
      fg: 'var(--coral-600)'
    },
    leaf: {
      bg: 'var(--leaf-100)',
      fg: 'var(--leaf-600)'
    },
    sky: {
      bg: 'var(--sky-100)',
      fg: 'var(--sky-600)'
    },
    berry: {
      bg: 'var(--berry-100)',
      fg: 'var(--berry-600)'
    }
  };
  const t = tones[tone] || tones.neutral;
  const pad = size === 'sm' ? '3px 9px' : '5px 13px';
  const fs = size === 'sm' ? 11 : 12.5;
  return /*#__PURE__*/React.createElement("span", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 5,
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: fs,
      letterSpacing: '0.02em',
      lineHeight: 1,
      padding: pad,
      borderRadius: 'var(--radius-pill)',
      color: t.fg,
      background: outline ? 'transparent' : t.bg,
      border: outline ? `1.5px solid ${t.fg}` : '1.5px solid transparent',
      ...style
    }
  }, rest), iconLeft, children);
}
Object.assign(__ds_scope, { Badge });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Badge.jsx", error: String((e && e.message) || e) }); }

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Button — the signature pill CTA with an ink "sticker" outline.
 * Variants map to the brand palette; all share rounded-pill geometry, a 2px
 * ink border, and a gentle press/hover lift.
 */
function Button({
  children,
  variant = 'primary',
  size = 'md',
  iconLeft = null,
  iconRight = null,
  fullWidth = false,
  disabled = false,
  type = 'button',
  onClick,
  style = {},
  ...rest
}) {
  const sizes = {
    sm: {
      fontSize: 13,
      padding: '8px 16px',
      gap: 6
    },
    md: {
      fontSize: 15,
      padding: '11px 22px',
      gap: 8
    },
    lg: {
      fontSize: 17,
      padding: '15px 30px',
      gap: 10
    }
  };
  const variants = {
    primary: {
      background: 'var(--yellow-400)',
      color: 'var(--ink-800)',
      border: '2px solid var(--ink-800)'
    },
    secondary: {
      background: 'var(--surface-raised)',
      color: 'var(--ink-800)',
      border: '2px solid var(--ink-800)'
    },
    teal: {
      background: 'var(--teal-400)',
      color: '#fff',
      border: '2px solid var(--ink-800)'
    },
    coral: {
      background: 'var(--coral-400)',
      color: '#fff',
      border: '2px solid var(--ink-800)'
    },
    ghost: {
      background: 'transparent',
      color: 'var(--ink-800)',
      border: '2px solid transparent'
    }
  };
  const s = sizes[size] || sizes.md;
  const v = variants[variant] || variants.primary;
  const lifted = variant !== 'ghost';
  return /*#__PURE__*/React.createElement("button", _extends({
    type: type,
    disabled: disabled,
    onClick: onClick,
    className: "boni-btn",
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: s.gap,
      width: fullWidth ? '100%' : 'auto',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: s.fontSize,
      lineHeight: 1,
      padding: s.padding,
      borderRadius: 'var(--radius-pill)',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.45 : 1,
      boxShadow: lifted ? 'var(--shadow-sticker-sm)' : 'none',
      transition: 'transform var(--dur-fast) var(--ease-out), box-shadow var(--dur-fast) var(--ease-out), background var(--dur-fast) var(--ease-out)',
      WebkitTapHighlightColor: 'transparent',
      ...v,
      ...style
    },
    onMouseDown: e => {
      if (!disabled && lifted) {
        e.currentTarget.style.transform = 'translate(2px,2px)';
        e.currentTarget.style.boxShadow = 'none';
      }
    },
    onMouseUp: e => {
      if (!disabled && lifted) {
        e.currentTarget.style.transform = '';
        e.currentTarget.style.boxShadow = 'var(--shadow-sticker-sm)';
      }
    },
    onMouseLeave: e => {
      if (lifted) {
        e.currentTarget.style.transform = '';
        e.currentTarget.style.boxShadow = 'var(--shadow-sticker-sm)';
      }
    }
  }, rest), iconLeft, children, iconRight);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Card.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Card — a warm rounded surface. Two looks: `soft` (shadow, no border)
 * and `sticker` (the signature ink outline + flat offset). Pads its content
 * unless `bare` is set (for full-bleed media at the top).
 */
function Card({
  children,
  look = 'soft',
  tone = 'card',
  bare = false,
  interactive = false,
  style = {},
  ...rest
}) {
  const tones = {
    card: 'var(--surface-card)',
    white: 'var(--surface-raised)',
    cream: 'var(--cream-200)',
    teal: 'var(--teal-100)',
    yellow: 'var(--yellow-100)'
  };
  const bg = tones[tone] || tones.card;
  const looks = {
    soft: {
      border: '1px solid var(--border-subtle)',
      boxShadow: 'var(--shadow-md)'
    },
    sticker: {
      border: '2px solid var(--ink-800)',
      boxShadow: 'var(--shadow-sticker)'
    },
    flat: {
      border: '1px solid var(--border-subtle)',
      boxShadow: 'none'
    }
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      background: bg,
      borderRadius: 'var(--radius-lg)',
      padding: bare ? 0 : 'var(--space-5)',
      overflow: 'hidden',
      transition: 'transform var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out)',
      cursor: interactive ? 'pointer' : 'default',
      ...looks[look],
      ...style
    },
    onMouseEnter: interactive ? e => {
      e.currentTarget.style.transform = 'translateY(-4px)';
    } : undefined,
    onMouseLeave: interactive ? e => {
      e.currentTarget.style.transform = '';
    } : undefined
  }, rest), children);
}
Object.assign(__ds_scope, { Card });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Card.jsx", error: String((e && e.message) || e) }); }

// components/core/Input.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Input — a rounded text field with an optional floating-style label,
 * helper text and error state. Border thickens to ink on focus.
 */
function Input({
  label,
  type = 'text',
  placeholder = '',
  value,
  defaultValue,
  onChange,
  helper,
  error,
  disabled = false,
  iconLeft = null,
  id,
  style = {},
  ...rest
}) {
  const [focused, setFocused] = React.useState(false);
  const inputId = id || React.useId();
  const borderColor = error ? 'var(--danger)' : focused ? 'var(--ink-800)' : 'var(--ink-300)';
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6,
      fontFamily: 'var(--font-text)',
      ...style
    }
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: inputId,
    style: {
      fontWeight: 800,
      fontSize: 13,
      color: 'var(--ink-700)'
    }
  }, label), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      background: disabled ? 'var(--cream-200)' : 'var(--surface-raised)',
      border: `2px solid ${borderColor}`,
      borderRadius: 'var(--radius-md)',
      padding: '0 14px',
      transition: 'border-color var(--dur-fast) var(--ease-out)',
      opacity: disabled ? 0.6 : 1
    }
  }, iconLeft && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ink-400)',
      display: 'flex'
    }
  }, iconLeft), /*#__PURE__*/React.createElement("input", _extends({
    id: inputId,
    type: type,
    placeholder: placeholder,
    value: value,
    defaultValue: defaultValue,
    onChange: onChange,
    disabled: disabled,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
    style: {
      flex: 1,
      border: 'none',
      outline: 'none',
      background: 'transparent',
      fontFamily: 'var(--font-text)',
      fontWeight: 600,
      fontSize: 15,
      color: 'var(--ink-800)',
      padding: '12px 0'
    }
  }, rest))), (helper || error) && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 12.5,
      fontWeight: 600,
      color: error ? 'var(--danger)' : 'var(--ink-500)'
    }
  }, error || helper));
}
Object.assign(__ds_scope, { Input });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Input.jsx", error: String((e && e.message) || e) }); }

// components/core/Rating.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Rating — friendly five-star score. Read-only for displaying reviews,
 * or interactive (pass onChange) for collecting them. Stars are warm yellow
 * with an ink outline, half-stars supported in read-only mode.
 */
function Rating({
  value = 5,
  count,
  size = 20,
  readOnly = true,
  onChange,
  showValue = false,
  style = {},
  ...rest
}) {
  const [hover, setHover] = React.useState(0);
  const shown = hover || value;
  const Star = ({
    fill
  }) => /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: `g${fill}`
  }, /*#__PURE__*/React.createElement("stop", {
    offset: `${fill * 100}%`,
    stopColor: "var(--yellow-400)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: `${fill * 100}%`,
    stopColor: "var(--cream-200)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5l2.9 5.9 6.5.95-4.7 4.58 1.1 6.47L12 17.4l-5.8 3.06 1.1-6.47L2.6 9.4l6.5-.95L12 2.5z",
    fill: fill > 0 ? `url(#g${fill})` : 'var(--cream-200)',
    stroke: "var(--ink-800)",
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  }));
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      fontFamily: 'var(--font-text)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      gap: 2,
      cursor: readOnly ? 'default' : 'pointer'
    },
    onMouseLeave: () => !readOnly && setHover(0)
  }, [1, 2, 3, 4, 5].map(i => {
    const fill = Math.max(0, Math.min(1, shown - i + 1));
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      onMouseEnter: () => !readOnly && setHover(i),
      onClick: () => !readOnly && onChange && onChange(i)
    }, /*#__PURE__*/React.createElement(Star, {
      fill: readOnly ? fill : i <= shown ? 1 : 0
    }));
  })), showValue && /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 800,
      fontSize: size * 0.7,
      color: 'var(--ink-800)'
    }
  }, value.toFixed(1)), count != null && /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 700,
      fontSize: size * 0.66,
      color: 'var(--ink-500)'
    }
  }, "(", count.toLocaleString(), ")"));
}
Object.assign(__ds_scope, { Rating });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Rating.jsx", error: String((e && e.message) || e) }); }

// components/core/Switch.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Switch — a rounded toggle with an ink outline. On = yellow track.
 */
function Switch({
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  label,
  id,
  style = {},
  ...rest
}) {
  const isControlled = checked !== undefined;
  const [internal, setInternal] = React.useState(defaultChecked);
  const on = isControlled ? checked : internal;
  const switchId = id || React.useId();
  const toggle = () => {
    if (disabled) return;
    if (!isControlled) setInternal(!on);
    onChange && onChange(!on);
  };
  return /*#__PURE__*/React.createElement("label", {
    htmlFor: switchId,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 10,
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? 0.5 : 1,
      fontFamily: 'var(--font-text)',
      fontWeight: 700,
      fontSize: 14.5,
      color: 'var(--ink-800)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("button", _extends({
    id: switchId,
    role: "switch",
    "aria-checked": on,
    type: "button",
    onClick: toggle,
    disabled: disabled,
    style: {
      position: 'relative',
      width: 48,
      height: 28,
      flex: 'none',
      borderRadius: 'var(--radius-pill)',
      border: '2px solid var(--ink-800)',
      background: on ? 'var(--yellow-400)' : 'var(--cream-200)',
      cursor: disabled ? 'not-allowed' : 'pointer',
      transition: 'background var(--dur-base) var(--ease-out)',
      padding: 0
    }
  }, rest), /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 2,
      left: on ? 22 : 2,
      width: 20,
      height: 20,
      borderRadius: '50%',
      background: 'var(--ink-800)',
      transition: 'left var(--dur-base) var(--ease-bounce)'
    }
  })), label && /*#__PURE__*/React.createElement("span", null, label));
}
Object.assign(__ds_scope, { Switch });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Switch.jsx", error: String((e && e.message) || e) }); }

// components/feedback/Dialog.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Dialog — a centered modal on a warm scrim. Sticker-outlined card with
 * an optional paw flourish, title, body and a footer for actions. Closes on
 * scrim click and Escape. Self-contained: pass your own Buttons into `footer`.
 */
function Dialog({
  open,
  onClose,
  title,
  children,
  footer,
  pawSrc,
  width = 440,
  style = {},
  ...rest
}) {
  React.useEffect(() => {
    if (!open) return;
    const onKey = e => e.key === 'Escape' && onClose && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  if (!open) return null;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: 'fixed',
      inset: 0,
      zIndex: 200,
      background: 'rgba(33,29,23,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 'var(--space-5)',
      animation: 'boniFade var(--dur-base) var(--ease-out)'
    }
  }, /*#__PURE__*/React.createElement("div", _extends({
    onClick: e => e.stopPropagation(),
    role: "dialog",
    "aria-modal": "true",
    style: {
      position: 'relative',
      width: '100%',
      maxWidth: width,
      background: 'var(--surface-card)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-xl)',
      boxShadow: 'var(--shadow-sticker)',
      padding: 'var(--space-7)',
      textAlign: 'center',
      fontFamily: 'var(--font-text)',
      animation: 'boniPop var(--dur-base) var(--ease-bounce)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Close",
    style: {
      position: 'absolute',
      top: 14,
      right: 14,
      width: 34,
      height: 34,
      borderRadius: '50%',
      border: '2px solid var(--ink-800)',
      background: 'var(--surface-raised)',
      cursor: 'pointer',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 16,
      lineHeight: 1,
      color: 'var(--ink-800)'
    }
  }, "\xD7"), pawSrc && /*#__PURE__*/React.createElement("img", {
    src: pawSrc,
    alt: "",
    style: {
      width: 52,
      marginBottom: 8
    }
  }), title && /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 24,
      color: 'var(--ink-800)',
      margin: '0 0 10px'
    }
  }, title), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15.5,
      lineHeight: 1.55,
      color: 'var(--ink-600)'
    }
  }, children), footer && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 12,
      justifyContent: 'center',
      marginTop: 'var(--space-6)',
      flexWrap: 'wrap'
    }
  }, footer)), /*#__PURE__*/React.createElement("style", null, `@keyframes boniFade{from{opacity:0}to{opacity:1}}@keyframes boniPop{from{opacity:0;transform:translateY(12px) scale(.96)}to{opacity:1;transform:none}}`));
}
Object.assign(__ds_scope, { Dialog });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/feedback/Dialog.jsx", error: String((e && e.message) || e) }); }

// components/navigation/Tabs.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni Tabs — a rounded segmented control for switching views (e.g. Dry food
 * / Wet food / Treats). Two looks: `pill` (filled active pill on a cream track)
 * and `underline` (active item gets a yellow underline). Controlled or not.
 */
function Tabs({
  tabs = [],
  value,
  defaultValue,
  onChange,
  look = 'pill',
  style = {},
  ...rest
}) {
  const isControlled = value !== undefined;
  const [internal, setInternal] = React.useState(defaultValue ?? (tabs[0] && tabs[0].id));
  const active = isControlled ? value : internal;
  const select = id => {
    if (!isControlled) setInternal(id);
    onChange && onChange(id);
  };
  if (look === 'underline') {
    return /*#__PURE__*/React.createElement("div", _extends({
      role: "tablist",
      style: {
        display: 'inline-flex',
        gap: 24,
        borderBottom: '2px solid var(--cream-300)',
        ...style
      }
    }, rest), tabs.map(t => {
      const on = t.id === active;
      return /*#__PURE__*/React.createElement("button", {
        key: t.id,
        role: "tab",
        "aria-selected": on,
        onClick: () => select(t.id),
        style: {
          appearance: 'none',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontFamily: 'var(--font-text)',
          fontWeight: 800,
          fontSize: 15,
          color: on ? 'var(--ink-800)' : 'var(--ink-500)',
          padding: '8px 2px 12px',
          marginBottom: -2,
          borderBottom: `3px solid ${on ? 'var(--yellow-400)' : 'transparent'}`,
          transition: 'color var(--dur-fast) var(--ease-out)'
        }
      }, t.label);
    }));
  }
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "tablist",
    style: {
      display: 'inline-flex',
      gap: 4,
      padding: 4,
      background: 'var(--cream-200)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-pill)',
      ...style
    }
  }, rest), tabs.map(t => {
    const on = t.id === active;
    return /*#__PURE__*/React.createElement("button", {
      key: t.id,
      role: "tab",
      "aria-selected": on,
      onClick: () => select(t.id),
      style: {
        appearance: 'none',
        cursor: 'pointer',
        border: 'none',
        fontFamily: 'var(--font-text)',
        fontWeight: 800,
        fontSize: 14.5,
        padding: '8px 18px',
        borderRadius: 'var(--radius-pill)',
        background: on ? 'var(--yellow-400)' : 'transparent',
        color: 'var(--ink-800)',
        boxShadow: on ? 'var(--shadow-sticker-sm)' : 'none',
        transition: 'background var(--dur-fast) var(--ease-out)'
      }
    }, t.label);
  }));
}
Object.assign(__ds_scope, { Tabs });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/Tabs.jsx", error: String((e && e.message) || e) }); }

// components/product/ProductCard.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Boni ProductCard — the shop tile. A tinted media panel up top, benefit
 * badges, name, variant + price, and an "Add to bowl" CTA. Self-contained
 * (mirrors the Badge + Button styling). Pass `image` for a product render, or
 * leave it for the paw-watermark placeholder panel.
 */
function ProductCard({
  name = 'Atlantic Salmon Adult Dry Food',
  variant = 'Adult · 2.5kg',
  price = '$26.99',
  oldPrice,
  image,
  pawSrc,
  tone = 'teal',
  badges = ['Grain-free', 'Fresh fish'],
  onAdd,
  style = {},
  ...rest
}) {
  const tones = {
    teal: 'var(--teal-100)',
    coral: 'var(--coral-100)',
    leaf: 'var(--leaf-100)',
    sky: 'var(--sky-100)',
    yellow: 'var(--yellow-100)',
    berry: 'var(--berry-100)'
  };
  const panel = tones[tone] || tones.teal;
  const badgeTones = [['var(--leaf-100)', 'var(--leaf-600)'], ['var(--teal-100)', 'var(--teal-600)'], ['var(--coral-100)', 'var(--coral-600)'], ['var(--sky-100)', 'var(--sky-600)'], ['var(--berry-100)', 'var(--berry-600)']];
  const chip = (label, i) => /*#__PURE__*/React.createElement("span", {
    key: label,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 4,
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 11,
      letterSpacing: '0.02em',
      lineHeight: 1,
      padding: '3px 9px',
      borderRadius: 'var(--radius-pill)',
      color: badgeTones[i % badgeTones.length][1],
      background: badgeTones[i % badgeTones.length][0]
    }
  }, label);
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      display: 'flex',
      flexDirection: 'column',
      background: 'var(--surface-card)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-sticker)',
      overflow: 'hidden',
      width: 280,
      fontFamily: 'var(--font-text)',
      ...style
    }
  }, rest), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      height: 188,
      background: panel,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, image ? /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: name,
    style: {
      width: '78%',
      height: '100%',
      objectFit: 'contain'
    }
  }) : pawSrc ? /*#__PURE__*/React.createElement("img", {
    src: pawSrc,
    alt: "",
    style: {
      width: 92,
      opacity: 0.6
    }
  }) : /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 18,
      color: 'var(--ink-400)'
    }
  }, "Product photo"), oldPrice && /*#__PURE__*/React.createElement("span", {
    style: {
      position: 'absolute',
      top: 12,
      left: 12,
      display: 'inline-flex',
      alignItems: 'center',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 12.5,
      lineHeight: 1,
      padding: '5px 13px',
      borderRadius: 'var(--radius-pill)',
      color: 'var(--coral-600)',
      background: 'var(--coral-100)'
    }
  }, "Save 50%")), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-5)',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
      flex: 1
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 6
    }
  }, badges.map(chip)), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 18,
      lineHeight: 1.2,
      color: 'var(--ink-800)',
      margin: 0
    }
  }, name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13.5,
      fontWeight: 600,
      color: 'var(--ink-500)'
    }
  }, variant), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      marginTop: 2
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 22,
      color: 'var(--ink-800)'
    }
  }, price), oldPrice && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 15,
      fontWeight: 700,
      color: 'var(--ink-400)',
      textDecoration: 'line-through'
    }
  }, oldPrice)), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'auto',
      paddingTop: 8
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: onAdd,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      width: '100%',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 15,
      lineHeight: 1,
      padding: '11px 22px',
      borderRadius: 'var(--radius-pill)',
      background: 'var(--yellow-400)',
      color: 'var(--ink-800)',
      border: '2px solid var(--ink-800)',
      boxShadow: 'var(--shadow-sticker-sm)',
      cursor: 'pointer'
    }
  }, "Add to bowl ", /*#__PURE__*/React.createElement("span", null, "\uD83D\uDC3E")))));
}
Object.assign(__ds_scope, { ProductCard });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/product/ProductCard.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/App.jsx
try { (() => {
// CartDrawer — slide-in bag.
function CartDrawer({
  open,
  items,
  onClose,
  onQty
}) {
  const {
    Button
  } = window.BoniDesignSystem_dec8ad;
  const subtotal = items.reduce((s, it) => s + it.qty * Number(String(it.price).replace(/[^0-9.]/g, '')), 0);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: 'fixed',
      inset: 0,
      background: 'rgba(33,29,23,0.45)',
      opacity: open ? 1 : 0,
      pointerEvents: open ? 'auto' : 'none',
      transition: 'opacity var(--dur-base) var(--ease-out)',
      zIndex: 100
    }
  }), /*#__PURE__*/React.createElement("aside", {
    style: {
      position: 'fixed',
      top: 0,
      right: 0,
      height: '100%',
      width: 'min(420px, 92vw)',
      background: 'var(--cream-100)',
      borderLeft: '2px solid var(--ink-800)',
      boxShadow: 'var(--shadow-lg)',
      transform: open ? 'translateX(0)' : 'translateX(100%)',
      transition: 'transform var(--dur-slow) var(--ease-out)',
      zIndex: 101,
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 'var(--space-5)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("h3", {
    style: {
      margin: 0,
      fontSize: 22
    }
  }, "Your bag"), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    style: {
      border: '2px solid var(--ink-800)',
      background: 'var(--surface-raised)',
      borderRadius: '50%',
      width: 36,
      height: 36,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "x",
    size: 18
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflowY: 'auto',
      padding: 'var(--space-5)',
      display: 'flex',
      flexDirection: 'column',
      gap: 14
    }
  }, items.length === 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      color: 'var(--ink-500)',
      marginTop: 40
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/boni-paw.png",
    alt: "",
    style: {
      width: 56,
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      fontWeight: 700,
      marginTop: 12
    }
  }, "Your bag is empty.")), items.map(it => /*#__PURE__*/React.createElement("div", {
    key: it.id,
    style: {
      display: 'flex',
      gap: 14,
      alignItems: 'center',
      background: 'var(--surface-card)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-md)',
      padding: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 56,
      height: 56,
      flex: 'none',
      borderRadius: 'var(--radius-sm)',
      background: 'var(--teal-100)',
      border: '2px solid var(--ink-800)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/boni-paw.png",
    alt: "",
    style: {
      width: 26,
      opacity: 0.7
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 15,
      color: 'var(--ink-800)',
      lineHeight: 1.2
    }
  }, it.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--ink-500)'
    }
  }, it.variant)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => onQty(it.id, -1),
    style: qtyBtn
  }, "\u2013"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 800,
      minWidth: 16,
      textAlign: 'center'
    }
  }, it.qty), /*#__PURE__*/React.createElement("button", {
    onClick: () => onQty(it.id, 1),
    style: qtyBtn
  }, "+"))))), /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 'var(--space-5)',
      borderTop: '2px solid var(--ink-800)',
      background: 'var(--cream-50)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 14,
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 20,
      color: 'var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "Subtotal"), /*#__PURE__*/React.createElement("span", null, "$", subtotal.toFixed(2))), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    fullWidth: true,
    iconRight: /*#__PURE__*/React.createElement("span", null, "\uD83D\uDC3E"),
    disabled: items.length === 0
  }, "Checkout"), /*#__PURE__*/React.createElement("p", {
    style: {
      textAlign: 'center',
      fontSize: 12.5,
      color: 'var(--ink-500)',
      fontWeight: 700,
      margin: '12px 0 0'
    }
  }, "Free shipping over $20 \xB7 50% off with WELCOME50"))));
}
const qtyBtn = {
  width: 28,
  height: 28,
  borderRadius: '50%',
  border: '2px solid var(--ink-800)',
  background: 'var(--surface-raised)',
  fontFamily: 'var(--font-text)',
  fontWeight: 800,
  fontSize: 16,
  lineHeight: 1,
  cursor: 'pointer',
  color: 'var(--ink-800)'
};
window.CartDrawer = CartDrawer;

// App — composes the whole site and owns cart state.
function App() {
  const [cart, setCart] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const count = cart.reduce((s, it) => s + it.qty, 0);
  const add = p => {
    setCart(c => {
      const found = c.find(it => it.id === p.id);
      if (found) return c.map(it => it.id === p.id ? {
        ...it,
        qty: it.qty + 1
      } : it);
      return [...c, {
        id: p.id,
        name: p.name,
        variant: p.variant,
        price: p.price,
        qty: 1
      }];
    });
    setOpen(true);
  };
  const changeQty = (id, d) => setCart(c => c.map(it => it.id === id ? {
    ...it,
    qty: it.qty + d
  } : it).filter(it => it.qty > 0));
  return /*#__PURE__*/React.createElement("div", {
    id: "top"
  }, /*#__PURE__*/React.createElement(Header, {
    cartCount: count,
    onCartClick: () => setOpen(true)
  }), /*#__PURE__*/React.createElement(Hero, {
    onShop: () => {
      const el = document.getElementById('shop');
      if (el) window.scrollTo({
        top: el.getBoundingClientRect().top + window.scrollY - 80,
        behavior: 'smooth'
      });
    }
  }), /*#__PURE__*/React.createElement(Benefits, null), /*#__PURE__*/React.createElement(IngredientBanner, null), /*#__PURE__*/React.createElement("div", {
    id: "shop"
  }, /*#__PURE__*/React.createElement(ProductGrid, {
    onAdd: add
  })), /*#__PURE__*/React.createElement(Testimonials, null), /*#__PURE__*/React.createElement(Foundation, null), /*#__PURE__*/React.createElement(Newsletter, null), /*#__PURE__*/React.createElement(Footer, null), /*#__PURE__*/React.createElement(CartDrawer, {
    open: open,
    items: cart,
    onClose: () => setOpen(false),
    onQty: changeQty
  }));
}
window.App = App;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/App.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Benefits.jsx
try { (() => {
// Benefits — the "9 out of 10" proof strip with three pillars.
function Benefits() {
  const items = [{
    icon: 'heart-pulse',
    tone: 'var(--coral-400)',
    bg: 'var(--coral-100)',
    title: 'Optimal digestion',
    body: 'Expertly cooked meat with prebiotics from yeast and chicory means easy digestion.'
  }, {
    icon: 'sparkles',
    tone: 'var(--teal-400)',
    bg: 'var(--teal-100)',
    title: 'Healthy skin & coat',
    body: 'Fresh meat contains more healthy fats — crucial to a shiny coat and happy skin.'
  }, {
    icon: 'shield-check',
    tone: 'var(--leaf-400)',
    bg: 'var(--leaf-100)',
    title: 'Supports immunity',
    body: 'A careful balance of Omega 3 & 6 fatty acids to support the immune system.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--cream-200)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 'clamp(1.8rem,3vw,2.4rem)',
      margin: '0 0 6px'
    }
  }, "9 out of 10 customers", /*#__PURE__*/React.createElement("br", null), "see the difference"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'var(--ink-500)',
      fontSize: 14,
      fontWeight: 600,
      margin: 0
    }
  }, "Results from a survey of 1,239 European customers.**")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,1fr)',
      gap: 'var(--space-6)'
    }
  }, items.map(it => /*#__PURE__*/React.createElement("div", {
    key: it.title,
    style: {
      background: 'var(--surface-card)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-sticker)',
      padding: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 64,
      height: 64,
      borderRadius: '50%',
      background: it.bg,
      border: '2px solid var(--ink-800)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: 18
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: it.icon,
    size: 30,
    color: it.tone
  })), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 21,
      margin: '0 0 8px'
    }
  }, it.title), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.55,
      color: 'var(--ink-600)',
      margin: 0
    }
  }, it.body))))));
}
window.Benefits = Benefits;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Benefits.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Footer.jsx
try { (() => {
// Newsletter — the cream sign-up band, then the footer.
function Newsletter() {
  const {
    Button,
    Input
  } = window.BoniDesignSystem_dec8ad;
  const [done, setDone] = React.useState(false);
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--yellow-400)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 760,
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter)',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/boni-paw.png",
    alt: "",
    style: {
      width: 48,
      marginBottom: 12
    }
  }), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 'clamp(1.9rem,3vw,2.6rem)',
      margin: '0 0 10px'
    }
  }, "Get 50% off \u2014 join the pack"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 17,
      color: 'var(--ink-700)',
      margin: '0 0 24px',
      fontWeight: 600
    }
  }, "Sign up for Boni emails for your discount, plus the latest news and offers."), done ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 10,
      background: 'var(--ink-800)',
      color: 'var(--cream-100)',
      borderRadius: 'var(--radius-pill)',
      padding: '12px 24px',
      fontFamily: 'var(--font-text)',
      fontWeight: 800
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "check",
    color: "var(--yellow-400)"
  }), " Thanks for subscribing!") : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      setDone(true);
    },
    style: {
      display: 'flex',
      gap: 12,
      maxWidth: 480,
      margin: '0 auto',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1
    }
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "you@example.com",
    type: "email"
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    type: "submit",
    style: {
      border: '2px solid var(--ink-800)',
      background: 'var(--surface-raised)'
    }
  }, "Sign up"))));
}
window.Newsletter = Newsletter;
function Footer() {
  const cols = [['Shop', ['All products', 'Dry food', 'Wet food', 'Treats', 'For puppies']], ['Learn', ['Our food', 'Our story', 'Our planet', 'Our foundation']], ['Support', ['Contact', 'Stores', 'FAQ', 'Shipping']]];
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: 'var(--ink-800)',
      color: 'var(--cream-100)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter) var(--space-7)',
      display: 'grid',
      gridTemplateColumns: '1.4fr 1fr 1fr 1fr',
      gap: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--cream-100)',
      display: 'inline-block',
      padding: '10px 14px',
      borderRadius: 'var(--radius-md)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/boni-logo.png",
    alt: "Boni",
    style: {
      height: 30,
      display: 'block'
    }
  })), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 14.5,
      color: 'var(--cream-300)',
      marginTop: 16,
      maxWidth: 260,
      lineHeight: 1.55
    }
  }, "Really good food for dogs. Real ingredients, expertly prepared."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 12,
      marginTop: 16
    }
  }, ['instagram', 'facebook', 'youtube'].map(s => /*#__PURE__*/React.createElement("span", {
    key: s,
    style: {
      width: 38,
      height: 38,
      borderRadius: '50%',
      border: '2px solid var(--cream-300)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: s,
    size: 18,
    color: "var(--cream-100)"
  }))))), cols.map(([h, links]) => /*#__PURE__*/React.createElement("div", {
    key: h
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 16,
      color: 'var(--yellow-400)',
      marginBottom: 14
    }
  }, h), links.map(l => /*#__PURE__*/React.createElement("a", {
    key: l,
    style: {
      display: 'block',
      color: 'var(--cream-200)',
      textDecoration: 'none',
      fontSize: 14.5,
      fontWeight: 600,
      padding: '5px 0',
      cursor: 'pointer'
    }
  }, l))))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: '1px solid rgba(255,255,255,0.12)',
      padding: '18px var(--gutter)',
      textAlign: 'center',
      fontSize: 13,
      color: 'var(--cream-300)',
      fontWeight: 600
    }
  }, "\xA9 2026 Boni \u2014 All rights reserved. \uD83D\uDC3E"));
}
window.Footer = Footer;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Footer.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Foundation.jsx
try { (() => {
// Foundation — the dark "stop pets from suffering" pledge band.
function Foundation() {
  const {
    Button
  } = window.BoniDesignSystem_dec8ad;
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--ink-800)',
      color: 'var(--cream-100)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter)',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 'var(--space-8)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "boni-eyebrow",
    style: {
      color: 'var(--yellow-400)'
    }
  }, "The Boni Foundation"), /*#__PURE__*/React.createElement("h2", {
    style: {
      color: 'var(--cream-50)',
      fontSize: 'clamp(2rem,3.4vw,2.8rem)',
      margin: '12px 0 16px'
    }
  }, "Stop pets", /*#__PURE__*/React.createElement("br", null), "from suffering"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 17,
      lineHeight: 1.55,
      color: 'var(--cream-200)',
      maxWidth: 420,
      margin: '0 0 24px'
    }
  }, "Too many dogs and cats live difficult, lonely and unnecessarily short lives. We pledge ", /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--yellow-400)'
    }
  }, "1% of every sale"), " to help stop that happening."), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    iconRight: /*#__PURE__*/React.createElement("span", null, "\u2192")
  }, "Learn more")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-5)'
    }
  }, [['$3.6M', 'donated so far'], ['4,500', 'dogs vaccinated'], ['1%', 'of every sale']].map(([n, l], i) => /*#__PURE__*/React.createElement("div", {
    key: l,
    style: {
      flex: 1,
      textAlign: 'center',
      background: 'rgba(255,255,255,0.06)',
      border: '2px solid var(--yellow-400)',
      borderRadius: 'var(--radius-lg)',
      padding: 'var(--space-6) var(--space-3)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 34,
      color: 'var(--yellow-400)',
      lineHeight: 1
    }
  }, n), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--cream-200)',
      marginTop: 8
    }
  }, l))))));
}
window.Foundation = Foundation;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Foundation.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Header.jsx
try { (() => {
// Boni marketing site — top navigation bar with cart.
function Header({
  cartCount,
  onCartClick
}) {
  const link = {
    fontFamily: 'var(--font-text)',
    fontWeight: 700,
    fontSize: 15,
    color: 'var(--ink-800)',
    textDecoration: 'none',
    cursor: 'pointer',
    padding: '6px 2px',
    whiteSpace: 'nowrap'
  };
  return /*#__PURE__*/React.createElement("header", {
    style: {
      position: 'sticky',
      top: 0,
      zIndex: 50,
      background: 'var(--cream-100)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ink-800)',
      color: 'var(--cream-100)',
      textAlign: 'center',
      fontFamily: 'var(--font-text)',
      fontWeight: 700,
      fontSize: 13,
      padding: '7px 16px',
      letterSpacing: '.01em'
    }
  }, "Get ", /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--yellow-400)'
    }
  }, "50% off"), " your first order with code ", /*#__PURE__*/React.createElement("strong", null, "WELCOME50"), " \xB7 Free shipping over $20 \uD83D\uDC3E"), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: '14px var(--gutter)',
      display: 'flex',
      alignItems: 'center',
      gap: 28
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#top",
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/boni-logo.png",
    alt: "Boni",
    style: {
      height: 34
    }
  })), /*#__PURE__*/React.createElement("nav", {
    style: {
      display: 'flex',
      gap: 22,
      marginLeft: 8
    }
  }, /*#__PURE__*/React.createElement("a", {
    style: link
  }, "Shop dog"), /*#__PURE__*/React.createElement("a", {
    style: link
  }, "Our food"), /*#__PURE__*/React.createElement("a", {
    style: link
  }, "Our story"), /*#__PURE__*/React.createElement("a", {
    style: link
  }, "Our planet")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("a", {
    style: {
      ...link,
      display: 'flex',
      alignItems: 'center',
      gap: 6
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "user"
  }), " ", /*#__PURE__*/React.createElement("span", {
    style: {}
  }, "Log in")), /*#__PURE__*/React.createElement("button", {
    onClick: onCartClick,
    style: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      background: 'var(--yellow-400)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-pill)',
      boxShadow: 'var(--shadow-sticker-sm)',
      padding: '8px 16px',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 14,
      color: 'var(--ink-800)',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "shopping-bag"
  }), " Cart", /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 20,
      height: 20,
      padding: '0 5px',
      borderRadius: 999,
      background: 'var(--ink-800)',
      color: 'var(--cream-100)',
      fontSize: 11,
      fontWeight: 800,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, cartCount)))));
}
window.Header = Header;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Header.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Hero.jsx
try { (() => {
// Hero — the opening statement.
function Hero({
  onShop
}) {
  const {
    Button,
    Badge
  } = window.BoniDesignSystem_dec8ad;
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--cream-100)',
      borderBottom: '2px solid var(--ink-800)',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter)',
      display: 'grid',
      gridTemplateColumns: '1.05fr 0.95fr',
      gap: 'var(--space-8)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "boni-eyebrow",
    style: {
      color: 'var(--teal-600)'
    }
  }, "Really good dog food"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: 'clamp(2.6rem, 5vw, 4rem)',
      lineHeight: 1.02,
      letterSpacing: '-.02em',
      margin: '12px 0 18px'
    }
  }, "Happy bellies,", /*#__PURE__*/React.createElement("br", null), "wagging tails."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 19,
      lineHeight: 1.5,
      color: 'var(--ink-600)',
      maxWidth: 460,
      margin: '0 0 26px'
    }
  }, "Real ingredients, expertly prepared. Dry food, wet food and treats for dogs who deserve nothing less."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 14,
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    iconRight: /*#__PURE__*/React.createElement("span", null, "\u2192"),
    onClick: onShop
  }, "Shop dog"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "lg"
  }, "Our food")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      marginTop: 26
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--yellow-500)',
      fontSize: 18,
      letterSpacing: 2
    }
  }, "\u2605\u2605\u2605\u2605\u2605"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: 'var(--font-text)',
      fontWeight: 700,
      fontSize: 14.5,
      color: 'var(--ink-600)'
    }
  }, "Loved by over ", /*#__PURE__*/React.createElement("strong", {
    style: {
      color: 'var(--ink-800)'
    }
  }, "1 million pets")))), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative',
      minHeight: 380,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 360,
      height: 360,
      background: 'var(--teal-100)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-blob)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/boni-paw.png",
    alt: "",
    style: {
      width: 150,
      opacity: 0.85
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 18,
      right: 8,
      transform: 'rotate(6deg)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      background: 'var(--surface-raised)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-pill)',
      boxShadow: 'var(--shadow-sticker-sm)',
      padding: '8px 14px',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 13,
      color: 'var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "leaf",
    size: 16,
    color: "var(--leaf-600)"
  }), " Grain-free")), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      bottom: 24,
      left: 0,
      transform: 'rotate(-5deg)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      background: 'var(--surface-raised)',
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-pill)',
      boxShadow: 'var(--shadow-sticker-sm)',
      padding: '8px 14px',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 13,
      color: 'var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "fish",
    size: 16,
    color: "var(--teal-600)"
  }), " Made with fresh fish")))));
}
window.Hero = Hero;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Hero.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Icons.jsx
try { (() => {
// Icon — inlines a Lucide SVG (stroke = currentColor) and caches it.
// Lucide static SVGs already use stroke="currentColor", so colour & size are
// controlled by the wrapping span's `color` / `font-size`.
const __iconCache = {};
function Icon({
  name,
  size = 20,
  strokeWidth = 2,
  color = 'currentColor',
  style = {}
}) {
  const [svg, setSvg] = React.useState(__iconCache[name] || '');
  React.useEffect(() => {
    let alive = true;
    if (__iconCache[name]) {
      setSvg(__iconCache[name]);
      return;
    }
    fetch(`https://unpkg.com/lucide-static@0.484.0/icons/${name}.svg`).then(r => r.ok ? r.text() : '').then(t => {
      if (!t) return;
      t = t.replace(/width="24"/, '').replace(/height="24"/, '');
      __iconCache[name] = t;
      if (alive) setSvg(t);
    }).catch(() => {});
    return () => {
      alive = false;
    };
  }, [name]);
  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    style: {
      display: 'inline-flex',
      width: size,
      height: size,
      color,
      lineHeight: 0,
      flex: 'none',
      ...style
    },
    dangerouslySetInnerHTML: {
      __html: svg.replace('<svg', `<svg width="${size}" height="${size}" stroke-width="${strokeWidth}"`)
    }
  });
}
window.Icon = Icon;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Icons.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/IngredientBanner.jsx
try { (() => {
// IngredientBanner — "a bowl full of real ingredients" as a field of chips.
function IngredientBanner() {
  const ingredients = [['Fresh chicken', 'coral'], ['Sweet potato', 'yellow'], ['Salmon', 'sky'], ['Blueberries', 'berry'], ['Spinach', 'leaf'], ['Carrots', 'coral'], ['Chicory root', 'teal'], ['Cranberry', 'berry'], ['Peas', 'leaf'], ['Seaweed', 'teal'], ['Apple', 'leaf'], ['Pumpkin', 'yellow']];
  const tones = {
    coral: ['var(--coral-100)', 'var(--coral-600)'],
    yellow: ['var(--yellow-100)', 'var(--yellow-800)'],
    sky: ['var(--sky-100)', 'var(--sky-600)'],
    berry: ['var(--berry-100)', 'var(--berry-600)'],
    leaf: ['var(--leaf-100)', 'var(--leaf-600)'],
    teal: ['var(--teal-100)', 'var(--teal-600)']
  };
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--cream-100)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter)',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 'clamp(1.8rem,3vw,2.4rem)',
      margin: '0 0 8px'
    }
  }, "A bowl full of real ingredients"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'var(--ink-600)',
      fontSize: 17,
      margin: '0 0 var(--space-6)'
    }
  }, "For happy bellies and wagging tails."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: 12,
      justifyContent: 'center',
      maxWidth: 760,
      margin: '0 auto'
    }
  }, ingredients.map(([label, t]) => /*#__PURE__*/React.createElement("span", {
    key: label,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 8,
      background: tones[t][0],
      color: tones[t][1],
      border: '2px solid var(--ink-800)',
      borderRadius: 'var(--radius-pill)',
      padding: '10px 18px',
      fontFamily: 'var(--font-text)',
      fontWeight: 800,
      fontSize: 15
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "../../assets/boni-paw.png",
    alt: "",
    style: {
      width: 16,
      height: 16,
      objectFit: 'contain'
    }
  }), " ", label)))));
}
window.IngredientBanner = IngredientBanner;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/IngredientBanner.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/ProductGrid.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
// ProductGrid — the shop row with a category filter (Tabs) + ProductCard tiles.
function ProductGrid({
  onAdd
}) {
  const {
    ProductCard,
    Button,
    Tabs
  } = window.BoniDesignSystem_dec8ad;
  const paw = '../../assets/boni-paw.png';
  const [cat, setCat] = React.useState('all');
  const products = [{
    id: 'salmon',
    cat: 'dry',
    name: 'Atlantic Salmon Adult Dry Food',
    variant: 'Adult · 2.5kg',
    price: '$13.49',
    oldPrice: '$26.99',
    tone: 'sky',
    badges: ['Grain-free', 'Fresh fish']
  }, {
    id: 'duck',
    cat: 'dry',
    name: 'Free-Run Duck with Venison',
    variant: 'Adult · 2.5kg',
    price: '$13.49',
    oldPrice: '$26.99',
    tone: 'coral',
    badges: ['Hypoallergenic', 'Grain-free']
  }, {
    id: 'chicken',
    cat: 'dry',
    name: 'Free-Run Chicken Adult Dry Food',
    variant: 'Adult · 700g',
    price: '$9.99',
    tone: 'yellow',
    badges: ['Fresh poultry', 'Grain-free']
  }, {
    id: 'beef-wet',
    cat: 'wet',
    name: 'Grass-Fed Beef Wet Food',
    variant: 'Adult · 400g',
    price: '$3.49',
    tone: 'berry',
    badges: ['85% meat', 'No fillers']
  }, {
    id: 'turkey-wet',
    cat: 'wet',
    name: 'Free-Run Turkey Wet Food',
    variant: 'Adult · 400g',
    price: '$3.49',
    tone: 'teal',
    badges: ['Fresh turkey', 'Grain-free']
  }, {
    id: 'fish-treats',
    cat: 'treats',
    name: 'Oven-Baked Fish Treats',
    variant: 'Snack · 100g',
    price: '$5.99',
    tone: 'leaf',
    badges: ['Single protein', 'Low fat']
  }];
  const shown = cat === 'all' ? products : products.filter(p => p.cat === cat);
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--cream-200)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 'var(--space-6)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "boni-eyebrow",
    style: {
      color: 'var(--coral-600)'
    }
  }, "Take 50% off your first order"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 'clamp(1.8rem,3vw,2.4rem)',
      margin: '8px 0 0'
    }
  }, "Fan favourites")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    tabs: [{
      id: 'all',
      label: 'All'
    }, {
      id: 'dry',
      label: 'Dry food'
    }, {
      id: 'wet',
      label: 'Wet food'
    }, {
      id: 'treats',
      label: 'Treats'
    }],
    value: cat,
    onChange: setCat
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--space-6)',
      justifyContent: 'center',
      flexWrap: 'wrap'
    }
  }, shown.map(p => /*#__PURE__*/React.createElement(ProductCard, _extends({
    key: p.id
  }, p, {
    pawSrc: paw,
    onAdd: () => onAdd(p)
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginTop: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "lg"
  }, "View all recipes"))));
}
window.ProductGrid = ProductGrid;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/ProductGrid.jsx", error: String((e && e.message) || e) }); }

// ui_kits/website/Testimonials.jsx
try { (() => {
// Testimonials — real pet-parent quotes with avatars.
function Testimonials() {
  const {
    Avatar,
    Rating
  } = window.BoniDesignSystem_dec8ad;
  const quotes = [{
    name: 'Bejarano',
    pet: 'Corgi parent',
    tone: 'yellow',
    text: 'Quality product, well appreciated by our corgi. Perfect digestion.'
  }, {
    name: 'Eduard',
    pet: 'Jack Russell parent',
    tone: 'teal',
    text: 'My dog loves them. Easy to break into pieces — even with missing teeth he chews them well. Top quality!'
  }, {
    name: 'Joel',
    pet: 'Labrador parent',
    tone: 'coral',
    text: 'It took us almost a year to find your products, but she absolutely loves them.'
  }];
  return /*#__PURE__*/React.createElement("section", {
    style: {
      background: 'var(--cream-100)',
      borderBottom: '2px solid var(--ink-800)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--container)',
      margin: '0 auto',
      padding: 'var(--space-9) var(--gutter)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center',
      marginBottom: 'var(--space-7)'
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 'clamp(1.8rem,3vw,2.4rem)',
      margin: '0 0 6px'
    }
  }, "Loved by over 1 million pets***"), /*#__PURE__*/React.createElement("p", {
    style: {
      color: 'var(--ink-500)',
      fontSize: 16,
      margin: 0
    }
  }, "And we have the reviews to prove it.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,1fr)',
      gap: 'var(--space-6)'
    }
  }, quotes.map(q => /*#__PURE__*/React.createElement("div", {
    key: q.name,
    style: {
      background: 'var(--surface-card)',
      border: '1px solid var(--border-subtle)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: 'var(--shadow-md)',
      padding: 'var(--space-6)',
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement(Rating, {
    value: 5,
    size: 16
  }), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 16,
      lineHeight: 1.55,
      color: 'var(--ink-700)',
      margin: 0,
      fontWeight: 600,
      flex: 1
    }
  }, "\u201C", q.text, "\u201D"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(Avatar, {
    name: q.name,
    tone: q.tone,
    size: 44
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--font-display)',
      fontWeight: 600,
      fontSize: 16,
      color: 'var(--ink-800)'
    }
  }, q.name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 13,
      fontWeight: 700,
      color: 'var(--ink-500)'
    }
  }, q.pet))))))));
}
window.Testimonials = Testimonials;
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/website/Testimonials.jsx", error: String((e && e.message) || e) }); }

__ds_ns.Avatar = __ds_scope.Avatar;

__ds_ns.Badge = __ds_scope.Badge;

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Card = __ds_scope.Card;

__ds_ns.Input = __ds_scope.Input;

__ds_ns.Rating = __ds_scope.Rating;

__ds_ns.Switch = __ds_scope.Switch;

__ds_ns.Dialog = __ds_scope.Dialog;

__ds_ns.Tabs = __ds_scope.Tabs;

__ds_ns.ProductCard = __ds_scope.ProductCard;

})();
